import React, { useEffect, useRef } from 'react';
import Shared from '../../Components/Frame/Shared';
import * as rsuite from 'rsuite';
import * as General from '../../General/General';
import * as Enum from '../../General/Enum';
import { MdOutlineSupportAgent } from "react-icons/md";
import { Table } from 'rsuite';
import { useState } from 'react';
import DatePicker from "react-datepicker2";
import moment from 'moment-jalaali';
import { isMobile } from 'react-device-detect';
import axios from 'axios';
import TicketMsgProp from '../../Components/Ticket/TicketMsgProp';
import ResponsiveList, { CardTitle, CardField, CardActions } from '../../Components/Shared/ResponsiveList';
import { UNSAFE_getTurboStreamSingleFetchDataStrategy } from 'react-router-dom';
import RowHeight from '../../Components/Shared/RowHeight';
const { Column, HeaderCell, Cell } = Table;
const AgentIndex = () => {


    //#region Const 
    const TicketRef = useRef();
    const PopupRef = useRef();
    const [ShowSearch, setShowSearch] = useState(false);
    const [State, setState] = useState(99);
    const [BeginDate, setBeginDate] = React.useState(null);
    const [EndDate, setEndDate] = React.useState(null);
    const [Number, setNumber] = useState("");
    const [Title, setTitle] = useState("");
    const [Data, setData] = useState([]);
    const [ShowLoading, setShowLoading] = useState(false);
    //#endregion

    //#region Handlers


    //#endregion 


    // #region Methods 

    const Bind = () => {
        setShowLoading(true);
        var RequestOption = {
            url: General.ApiRoute() + "/Ticket/AgentCartable?Title=" + Title,
            method: "Get",
            headers: {
                "ApiKey": process.env.REACT_APP_APIKEY,
                "Number": Number,
                "BeginDate": BeginDate ? BeginDate.format('jYYYY/jMM/jDD') : '',
                "EndDate": EndDate ? EndDate.format('jYYYY/jMM/jDD') : '',
                "State": State

            },
            withCredentials: true
        }

        axios(RequestOption)
            .then(function (res) {
                setShowLoading(false);
                setShowSearch(false)
                console.dir(res.data);
                setData(res.data);
            })
    }

    const ShowTicketMsg = (Id, Number) => {
        setShowLoading(true);
        if (PopupRef.current) { PopupRef.current.close(); }
        TicketRef.current.Show(Id, Number);
        setShowLoading(false);
    }

    useEffect(() => {
        Bind();
        const intervalId = setInterval(() => {

            Bind();
        }, 30 * 60 * 1000); // 

        return () => clearInterval(intervalId);
    }, [])

    const UpdateState = (ticketId, state) => {
        setShowLoading(true);
        if (PopupRef.current) { PopupRef.current.close(); }
        var RequestOption = {
            method: "POST",
            url: General.ApiRoute() + "/Ticket/UpdateCheckState",
            headers: {
                ApiKey: process.env.REACT_APP_APIKEY,
                id: ticketId,
                state: state,
                userId: General.GuidEmpty(),
                AgentSeenState: false,
                CreatorSeenState: false

            },
            withCredentials: true
        }
        axios(RequestOption)

            .then(function (res) {
                setShowLoading(false);
                Bind();
            }).catch(error => {
                setShowLoading(false);
                console.log(error);
            })
    }
    //#endregion 

    return (
        <Shared pageTitle={<><MdOutlineSupportAgent size={25} /> تیکت ها</>}>
            <div align="left">
                {
                    ShowLoading ?
                        <rsuite.Button appearance="primary" color="green" className="mb-2 ms-2" disabled>
                            <rsuite.Loader content="بازسازی"></rsuite.Loader>
                        </rsuite.Button>
                        :
                        <rsuite.Button appearance="primary" color="green" className="mb-2 ms-2" onClick={Bind}>
                            بازسازی
                        </rsuite.Button>
                }

                {
                    ShowLoading ?
                        <rsuite.Button appearance="primary" className="mb-2 ms-2" disabled>
                            <rsuite.Loader content="جستجو"></rsuite.Loader>
                        </rsuite.Button>
                        :
                        <rsuite.Button appearance="primary" className="mb-2 ms-2" onClick={() => setShowSearch(true)}>
                            جستجو
                        </rsuite.Button>
                }

            </div>
            <rsuite.Divider />
            <ResponsiveList
                fillHeight
                data={Data}
                loading={ShowLoading}
                emptyText="تیکتی یافت نشد"
                filters={[
                    { key: 'number', label: 'شماره', type: 'text' },
                    { key: 'companyTitle', label: 'مشتری', type: 'text' },
                    { key: 'creatorName', label: 'ایجاد کننده', type: 'text' },
                    { key: 'title', label: 'عنوان', type: 'text' },
                    { key: 'stateComment', label: 'وضعیت', type: 'select' }
                ]}
                renderCard={(rowData) => (
                    <>
                        <CardTitle>
                            {
                                rowData.agentSeenState ?
                                    <rsuite.Tag color="red" className='ms-2'>جدید</rsuite.Tag>
                                    :
                                    null
                            }
                            {rowData.title}
                        </CardTitle>
                        <CardField label="شماره">{rowData.number}</CardField>
                        <CardField label="مشتری">{rowData.companyTitle}</CardField>
                        <CardField label="ایجاد کننده">{rowData.creatorName}</CardField>
                        <CardField label="تاریخ">{rowData.date}</CardField>
                        <CardField label="آخرین به روز رسانی">{rowData.lastUpdateDate}</CardField>
                        <CardField label="وضعیت">{rowData.stateComment}</CardField>
                        <CardActions>
                            <rsuite.Button size="sm" appearance="primary"
                                onClick={() => ShowTicketMsg(rowData.id, rowData.number)}>جزئیات</rsuite.Button>
                            <rsuite.Button size="sm" className='ms-2'
                                onClick={() => UpdateState(rowData.id, Enum.StateType.WaitingList)}>در صف انتظار</rsuite.Button>
                            <rsuite.Button size="sm" className='ms-2'
                                onClick={() => UpdateState(rowData.id, Enum.StateType.Close)}>بستن تیکت</rsuite.Button>
                        </CardActions>
                    </>
                )}
            >
                <Table
                    rtl={true}
                    className='w-100'
                    bordered
                    headerHeight={40}
                    rowHeight={RowHeight}
                    wordWrap="break-word"
                    data={Data}
                    ShowLoading={ShowLoading}
                    rowClassName={(rowData) => {

                        return rowData?.agentSeenState && rowData.agentSeenState === true ? 'font-weight-bold' : ''

                    }}
                >
                    <Column >
                        <HeaderCell ><b>ردیف</b></HeaderCell>
                        <General.RowNumber />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell ><b>شماره</b></HeaderCell>
                        <Cell dataKey="number" />
                    </Column>

                    <Column flexGrow={1}>
                        <HeaderCell><b>تاریخ</b></HeaderCell>
                        <Cell dataKey="date" />
                    </Column>

                    <Column flexGrow={1}>
                        <HeaderCell><b>ایجاد کننده</b></HeaderCell>

                        <Cell>
                            {(rowData) => (
                                <>
                                    <div>{rowData.companyTitle}</div>
                                    <div>{rowData.creatorName}</div>
                                </>
                            )}
                        </Cell>
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b>ایجاد کننده</b></HeaderCell>
                        <Cell dataKey="creatorName" />
                    </Column>
                    <Column flexGrow={3}>
                        <HeaderCell><b>عنوان</b></HeaderCell>
                        <Cell dataKey="title" />
                    </Column>

                    <Column flexGrow={1}>
                        <HeaderCell><b> آخرین به روز رسانی</b></HeaderCell>
                        <Cell dataKey="lastUpdateDate" />
                    </Column>
                    <Column flexGrow={1}>
                        <HeaderCell><b></b>آخرین وضعیت</HeaderCell>
                        <Cell dataKey="stateComment" />
                    </Column>
                    <Column fixed="right" className='Popup'>
                        <HeaderCell>عملیات</HeaderCell>
                        <Cell >
                            {rowData => (
                                <rsuite.Whisper
                                    placement="bottomStart"
                                    controlId="control-id-with-dropdown"
                                    trigger="click"
                                    ref={PopupRef}
                                    speaker={
                                        <rsuite.Popover full>
                                            <rsuite.Dropdown.Menu >
                                                {
                                                    ShowLoading ?
                                                        <>
                                                            <rsuite.Dropdown.Item >
                                                                <rsuite.Loader content="جزئیات" />
                                                            </rsuite.Dropdown.Item>
                                                            <rsuite.Dropdown.Item ><rsuite.Loader content="در صف انتظار" /></rsuite.Dropdown.Item>
                                                            <rsuite.Dropdown.Item ><rsuite.Loader content="بستن تیکت" /></rsuite.Dropdown.Item>
                                                        </>
                                                        :
                                                        <>
                                                            <rsuite.Dropdown.Item onClick={() => ShowTicketMsg(rowData.id, rowData.number)}>جزئیات</rsuite.Dropdown.Item>
                                                            <rsuite.Dropdown.Item onClick={() => UpdateState(rowData.id, Enum.StateType.WaitingList)}>در صف انتظار</rsuite.Dropdown.Item>
                                                            <rsuite.Dropdown.Item onClick={() => UpdateState(rowData.id, Enum.StateType.Close)}>بستن تیکت</rsuite.Dropdown.Item>
                                                        </>
                                                }


                                            </rsuite.Dropdown.Menu>
                                        </rsuite.Popover>
                                    }
                                >
                                    <rsuite.Button>...</rsuite.Button>
                                </rsuite.Whisper>
                            )}
                        </Cell>
                    </Column>
                </Table>
            </ResponsiveList>

            <rsuite.Drawer open={ShowSearch} onClose={() => setShowSearch(false)} placement={isMobile ? 'bottom' : 'right'} size={isMobile ? 'full' : 'sm'} >
                <rsuite.Drawer.Header>

                    <rsuite.Drawer.Actions>
                        {
                            ShowLoading ?
                                <rsuite.Button appearance='primary' disabled>
                                    <rsuite.Loader content="جستجو" />
                                </rsuite.Button>
                                :
                                <rsuite.Button appearance='primary' onClick={Bind}>جستجو</rsuite.Button>
                        }


                    </rsuite.Drawer.Actions>
                </rsuite.Drawer.Header>
                <rsuite.Drawer.Body>
                    <div className='mb-2'>
                        <label>از تاریخ</label>

                        <DatePicker className="form-control" isGregorian={false} timePicker={false} value={BeginDate} inputJalaaliFormat='jYYYY/jMM/jDD'
                            onChange={(value) => setBeginDate(value)} />

                    </div>
                    <div className='mb-2'>
                        <label>تا تاریخ</label>
                        <DatePicker className="form-control" isGregorian={false} timePicker={false} value={EndDate} inputJalaaliFormat='jYYYY/jMM/jDD'
                            onChange={(value) => setEndDate(value)} />
                    </div>
                    <div className='mb-2'>
                        <label>

                            شماره درخواست

                        </label>
                        <rsuite.Input className='w-100' value={Number} onChange={value => setNumber(value)}></rsuite.Input>

                    </div>
                    <div className='mb-2'>
                        <label>

                            عنوان

                        </label>
                        <rsuite.Input className='w-100' value={Title} onChange={value => setTitle(value)}></rsuite.Input>

                    </div>
                    <div className='mb-2'>
                        <label>وضعیت</label>
                        <rsuite.SelectPicker
                            searchable={false}
                            onClean={() => setState(-1)}
                            data={[
                                { label: "تمام درخواست ها", value: "-1" },
                                { label: "ثبت اولیه", value: "0" },
                                { label: "در دست بررسی", value: "1" },
                                { label: "پاسخ داده شده", value: "2" },
                                { label: "بسته شده", value: "3" },
                                { label: "در صف انتظار", value: "4" },
                                { label: "درخواست های باز", value: "99" }
                            ]}
                            value={State}
                            onChange={value => setState(value)}
                            className="w-100"
                            placeholder="انتخاب کنید"
                        />
                    </div>
                </rsuite.Drawer.Body>
            </rsuite.Drawer>

            <TicketMsgProp ref={TicketRef} onSubmit={Bind} />



        </Shared>
    );



}

export default AgentIndex;
